import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LicenseUploadModal from "@preferredMedical/Widgets/ShippingDetails/LicenseUploadModal";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    emailRecipients: getSettingsCollection(state).licenseUploadEmailRecipients as string,
    title: getSettingsCollection(state).licenseUploadNdcTitle as string,
    description: getSettingsCollection(state).licenseUploadNdcDescription as string,
    requiredFieldsLabel: getSettingsCollection(state).licenseUploadNdcRequiredFieldsLabel as string,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const cssWrapper = {
    css: css`
        text-align: center;
    `,
};

const LicenseUploadWButton: React.FC<Props> = ({ emailRecipients, title, description, requiredFieldsLabel }) => {
    return (
        <StyledWrapper {...cssWrapper}>
            <LicenseUploadModal
                emailRecipients={emailRecipients}
                title={title}
                description={description}
                requiredFieldsLabel={requiredFieldsLabel}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(LicenseUploadWButton),
    definition: {
        displayName: "License Upload",
        group: "Addresses",
        allowedContexts: ["AddressBookOverlay", "AddressesPage", "CheckoutShippingPage", "CheckoutReviewAndSubmitPage"],
    },
};

export default widgetModule;